import { useCallback } from 'react';
import { notificationActions } from 'components/notifications/actions/notification';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
export var NotificationType;
(function (NotificationType) {
    NotificationType[NotificationType["Error"] = 0] = "Error";
    NotificationType[NotificationType["Success"] = 1] = "Success";
})(NotificationType || (NotificationType = {}));
const NOTIFICATION_MAP = {
    [NotificationType.Error]: {
        title: 'An error occurred',
        className: 'danger',
        icon: 'exclamation',
    },
    [NotificationType.Success]: {
        title: 'Success',
        className: 'success',
        icon: 'done',
    },
};
const { notificationAdd } = notificationActions;
export const useNotifications = () => {
    const dispatch = useAppDispatch();
    const addNotification = useCallback((payload, type) => {
        const notificationTypeDefaultValues = NOTIFICATION_MAP[type !== null && type !== void 0 ? type : ''] || {};
        const notification = Object.assign(Object.assign({}, notificationTypeDefaultValues), payload);
        dispatch(notificationAdd(notification));
    }, [dispatch]);
    return addNotification;
};
